<script>
import { required } from "vuelidate/lib/validators";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Drawer from "vue-simple-drawer";
import Loader from "@/components/widgets/loader";
import RiskCevaplari from "./RiskCevaplari.vue";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrRisklerGirislerCevap from "@/models/StrRisklerGirislerCevap";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
import AddEdit from "./AddEdit.vue";
import StrRisk from "@/models/StrRisk";
export default {
  mixins: [Api, Sabit, StrRisklerGirislerCevap,StrRisk],
  page: {
    title: "Risk Değ. ve Cevaplar",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    Drawer,
    RiskCevaplari,
    AddEdit,
    formcombobox,
    BirimSecimi
  },
  data() {
    return {
      title: this.$t("StrRisklerGirislerCevap.Title"),
      items: [
        {
          text: this.$t("StrRisklerGirislerCevap.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrRisklerGirislerCevap.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrRisklerGirislerCevap.Title"),
          active: true,
        },
      ],
      FilitrelemePenceresi: true,
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      GirisId: "",
      DonemTipId:"",
      Update:0,
      sayac:0,
      Filter: {
        DonemId: "",
        UstDonemId: "",
        DurumId: "",
        BirimId: null,
        Risktipi:"",
      },
      DonemIdComboBox: [],
      UstDonemIdComboBox: [],
      DurumIdCombobox: [],
      BirimIdCombobox: [],
    };
  },
  validations: {
    Filter: {
      UstDonemId: { required },
      DonemId: { required },
      DurumId: {},
      BirimId: {required},
      Risktipi:{ required },
    },
  },
  methods: {
    Get() {},
    UpdateStr(data) {
      this.sayac=this.sayac+1;
      this.DataUpdate = data;
    },
    islemAlt(islem) {
      this.AddEdit = islem;
  
    },
    FilterGet() {
      this.$v.$touch();
      if (!this.$v.$invalid) {

        let Filter ="&Asc=Risk"
        if (this.Filter.Risktipi!=null && this.Filter.Risktipi!="") Filter=Filter+"&Risktipi=" +this.Filter.Risktipi;
        if (this.Filter.DonemId!=null && this.Filter.DonemId!=""){Filter=Filter+"&DonemId=" + this.Filter.DonemId;}
        if (this.Filter.DurumId!=null && this.Filter.DurumId!=""){Filter=Filter+"&DurumId=" + this.Filter.DurumId;}
        if (this.Filter.BirimId!=null && this.Filter.BirimId!=""  && this.Filter.BirimId!="1")
        {Filter=Filter+"&BirimId=" + this.Filter.BirimId;}
        console.log(Filter)
        this.ActionsFilterGet({ Service: "StrRiskGiris", Page: this.Page, Filter: Filter }).then((res) => {
          this.TableData = res.Data;
          this.Page.PageDataSize = res.TotalCount;
        });

        this.rightDrawer();
      }
    },
    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },

    guncelle(gelen){

      this.Update=this.Update+gelen;
    },

    DonemSec(){  
      
      let Page = {
      PageNumber: "1",
      PageSize: "9999",
      }; 
      this.DonemIdComboBox=[];
      
      let Filter ="&UstId="+this.Filter.UstDonemId+"&Approval=true"
      this.ActionsFilterGet({Service:"StrPerfDonem", Page:Page,Filter:Filter}).then((res) => {
          for (var i = 0; i < res.Data.length; i++) {
              this.DonemIdComboBox.push({
                Id: res.Data[i].Id,
                Value: res.Data[i].Aciklama,
                YilBas: res.Data[i].YilBas,
              }); 
            
          }

         
      }); 
    },
  },
  created() {
    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };

    this.ActionsSabitGet(1561).then((res) => {
      let donem_tipleri= res.Data;
      
      for (var i=0;i<donem_tipleri.length;i++){
          if(donem_tipleri[i].Kod=="5"){
            this.DonemTipId = donem_tipleri[i].Id;
          
          }
      }

          this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: "&TipId="+this.DonemTipId+"&Approval=true" }).then((res) => {
              for (var i = 0; i < res.Data.length; i++) {
                  if (!res.Data[i].UstId) {

                      this.UstDonemIdComboBox.push({ Id: res.Data[i].Id, Value: res.Data[i].Aciklama });

                  }
              }
          });

  });

    this.ActionsSabitGet(1557).then((res) => {
      this.DurumIdCombobox = res.Data;
    });

    this.ActionsGet({ Service: "OBirim", Page: Page }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.BirimIdCombobox.push({ Id: res.Data[i].Id, Value: res.Data[i].BirimAdi });
      }
    });
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
  
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4"></div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                    <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2" @click="rightDrawer"><i class="mdi mdi-text-search me-1"></i> {{ this.$t("StrRisklerGirislerCevap.Page.Filtreleme") }}</button>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table table-striped table-bordered mb-0" v-if="TableData.length">
                  <thead>
                    <tr>
                      <th scope="col"></th>
                      <th scope="col">{{ $t("StrRisklerGirislerCevap.Table.Risk") }}</th>
                      <th scope="col">{{ $t("StrRisklerGirislerCevap.Table.Durum") }}</th>
                      <th scope="col">{{ $t("StrRisklerGirislerCevap.Table.RiskPuani") }}</th>
                      <th scope="col" style="width: 185px; text-align: center; vertical-align: middle;">{{ $t("StrRisklerGirislerCevap.Table.Islem") }}</th>
                    </tr>
                  </thead>
                  <tbody v-for="(TableDataVerileri, index) in TableData" :key="TableDataVerileri.Id">
                    <tr>
                      <th scope="row" class="custom-accordion">
                        <a
                          class="
                            text-body
                            fw-medium
                            py-1
                            d-flex
                            align-items-center
                          "
                          data-toggle="collapse"
                          v-b-toggle="'CollapseAltTablo' + index"
                          role="button"
                          aria-expanded="false"
                          aria-controls="categories-collapse"
                        >
                          <i class="mdi mdi-chevron-up accor-down-icon ms-auto"></i>
                        </a>
                      </th>
                      <td>{{ TableDataVerileri.Risk }}</td>
                      <td>{{ TableDataVerileri.Durum }}</td>
                      <td>{{ TableDataVerileri.RiskPuani }}</td>
                      <td style="width: 185px; text-align: center; vertical-align: middle;">

                        <b-button ariant="success" v-b-modal.StrRisklerGirislerCevap 
                        @click="(DataUpdate = StrRisklerGirislerCevapData), (AddEdit = 'Add'), 
                        (GirisId = TableDataVerileri.Id),(sayac=sayac+1)">{{ $t("StrRisklerGirislerCevap.Table.CevapEkleButton") }}
                        </b-button>

                      </td>
                    </tr>

                    <tr>
                      <td colspan="5">
                        <b-collapse class="collapse show" :id="'CollapseAltTablo' + index">

                          <RiskCevaplari :GirisId="TableDataVerileri.Id" :Update="Update"
                          @DataUpdate="UpdateStr($event)" 
                          @AddEdit="islemAlt($event)" />
                          
                        </b-collapse>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" :GirisId="GirisId" :Sayac="sayac" 
      @TableUpdate="guncelle($event)"  />

      <Drawer @close="rightDrawer" :align="'right'" :closeable="true" :maskClosable="true" :zIndex="1002">
        <div style="width: 400px;" v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("StrRisklerGirislerCevap.Filtreleme.Title") }}
            </h5>
          </div>
          <div >
            {{ $t("StrRisklerGirislerCevap.Filtreleme.Content") }}
            <br>
            <br>
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'Risktipi',
                  Field: 'combobox',
                  FieldTitle: $t('StrRiskler.Filtreleme.Risktipi'),
                  ComboDataArray: FormDataType.Risktipi.ComboDataArray,
                }"
                :Value="Filter.Risktipi"
                :v="$v.Filter.Risktipi"
                @input="(Filter.Risktipi = $event)"
              />
            </div>
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'UstDonemId',
                  Field: 'combobox',
                  FieldTitle: $t('StrRisklerGirislerCevap.Filtreleme.UstDonemId'),
                  ComboDataArray: UstDonemIdComboBox,
                }"
                :Value="Filter.UstDonemId"
                :v="$v.Filter.UstDonemId"
                @input="Filter.UstDonemId = $event, DonemSec()"
              />
            </div>
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'DonemId',
                  Field: 'combobox',
                  FieldTitle: $t('StrRisklerGirislerCevap.Filtreleme.DonemId'),
                  ComboDataArray: DonemIdComboBox,
                }"
                :Value="Filter.DonemId"
                :v="$v.Filter.DonemId"
                @input="Filter.DonemId = $event"
              />
            </div>

            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'DurumId',
                  Field: 'combobox',
                  FieldTitle: $t('StrRisklerGirislerCevap.Filtreleme.DurumId'),
                  ComboDataArray: DurumIdCombobox,
                }"
                :Value="Filter.DurumId"
                :v="$v.Filter.DurumId"
                @input="Filter.DurumId = $event"
              />
            </div>
            <div class="mb-3">



            <b-form-group
                  class="mb-2"
                  id="birimler"
                  :label= "$t('StrRisklerGirislerCevap.Filtreleme.BirimId')"
                  label-for="text"
                >
                  <BirimSecimi
                    :title_position="'mb-3'"
                    :selected="Filter.BirimId"
                    :labels_lg="'3'"  
                    :YetkiKontrol="1"
                    :multiple="false"
                    :BirimTipId="null"
                    @Secilmis_Idler="Filter.BirimId=$event"
                  />
              </b-form-group>

            </div>


            <b-button @click="FilterGet()" class="btn btn-primary" variant="primary">{{ $t("StrRisklerGirislerCevap.Filtreleme.Button") }}</b-button>
          </div>
        </div>
      </Drawer>
    </Layout>
  </Loader>
</template>
